export const GET_WALK_ROUTES_REQUEST = 'GET_WALK_ROUTES_REQUEST';
export const GET_WALK_ROUTES_SUCCESS = 'GET_WALK_ROUTES_SUCCESS';
export const GET_WALK_ROUTES_FAILURE = 'GET_WALK_ROUTES_FAILURE';

export const DELETE_WALK_ROUTE_REQUEST = 'DELETE_WALK_ROUTE_REQUEST';
export const DELETE_WALK_ROUTE_SUCCESS = 'DELETE_WALK_ROUTE_SUCCESS';
export const DELETE_WALK_ROUTE_FAILURE = 'DELETE_WALK_ROUTE_FAILURE';
